import { parse } from "date-fns";

import { IEmailTemplate } from "store/entities/email-template/interfaces";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deserialize(object: any): IEmailTemplate {
  return {
    id: object.ID,
    createdBy: object.createdBy,
    createdByType: object.createdByType,
    createdAt: parse(object.createdAt),
    updatedBy: object.updatedBy,
    updatedByType: object.updatedByType,
    updatedAt: parse(object.updatedAt),
    licenseID: object.licenseID,
    name: object.name,
    content: object.content,
    type: object.type,
  };
}
